import { Component, EventEmitter, Input, Output, ContentChild, TemplateRef } from '@angular/core';
import {
  BalanceService,
  CompletedTriviaQuestion,
  config,
  GameGroupPrizeType,
  GroupType,
  ITriviaQuestion,
  QuestionStatus,
  TriviaGroupGames,
} from '@fgb/core';

@Component({
  selector: 'fgbcl-game-trivia-question-list',
  templateUrl: './game-trivia-question-list.component.html',
  styleUrls: ['./game-trivia-question-list.component.scss'],
})
export class GameTriviaQuestionListComponent {
  currentQuestionIndex = 0;
  questionStatuses: QuestionStatus[] = [];
  questionStatusType = QuestionStatus;
  groupType = GroupType.Trivia;
  correctAnswers = 0;
  @Input() gameDetails: TriviaGroupGames;
  @Input() groupId: number;
  @Input() isExternal: boolean = false;
  @Output() closeModal = new EventEmitter();
  @Output() isGameCompleted = new EventEmitter();
  sharedRedirectURL: string = 'games/trivia';
  isLoading = true; // Added loading stat
  @ContentChild('customContent', { static: false }) customContentTemplate: TemplateRef<any>;
  loadingState: boolean = false;
  isTransitioning = false;
  constructor(private balanceService: BalanceService) {}

  ngOnInit() {
    this.questionStatuses = this.gameDetails.Questions.flatMap((question) => question.Status);
    this.currentQuestionIndex = this.gameDetails.Questions.filter(
      (question) => question.Status != QuestionStatus.NotStarted
    ).length;

    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  }

  setLoadingState(loadingState: boolean) {
    this.loadingState = loadingState;
  }

  onAnswerSelected(index: number, gameDetails: TriviaGroupGames) {
    this.isTransitioning = false;
    this.questionStatuses[index] = gameDetails.Questions[this.currentQuestionIndex].Status;
    if (this.questionStatuses[index] == QuestionStatus.Correct) {
      this.correctAnswers++;
    }

    if (gameDetails.Completed) {
      let pointsAwarded = this.getTotalPointsAwarded(gameDetails);
      if (pointsAwarded > 0) {
        this.balanceService.addBalance(config.purseConfig.virtualLoyalty, pointsAwarded);
      }
      this.isGameCompleted.emit(true);
    }
    this.updateTriviaGroup(gameDetails);
  }

  updateTriviaGroup(gameDetails: TriviaGroupGames) {
    setTimeout(() => {
      this.isTransitioning = true;
    }, 800);
    setTimeout(() => {
      this.gameDetails = gameDetails;
      if (!this.gameDetails.Completed) {
        this.currentQuestionIndex++;
        this.isTransitioning = false;
      } else {
        this.currentQuestionIndex = this.gameDetails.Questions.length;
        this.isTransitioning = false;
      }
    }, 1500);
  }

  getTotalPointsAwarded(gameDetails: TriviaGroupGames): number {
    if (gameDetails.EntityPointsAwarded == 0) {
      let completedQuestions = gameDetails.Questions as CompletedTriviaQuestion[];
      let pointsFromQuestions = completedQuestions.reduce(function (a, b) {
        return a + b['PointsAwarded'];
      }, 0);

      let prize = (gameDetails as TriviaGroupGames).Prize;
      if (prize && prize.PrizeType == GameGroupPrizeType.Points && +prize.PrizeValue) {
        return +prize.PrizeValue;
      } else {
        return pointsFromQuestions;
      }
    } else {
      return gameDetails.EntityPointsAwarded;
    }
  }

  closeModalButton() {
    this.closeModal.emit();
  }

  trackByFn(index: number, item: ITriviaQuestion) {
    return index;
  }
}
